import { render, staticRenderFns } from "./company-user.vue?vue&type=template&id=c6921ae8&"
import script from "./company-user.vue?vue&type=script&lang=js&"
export * from "./company-user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports